import React from "react";
import img1 from "../../images/manufacturerBenefits/service (1).svg";
import img2 from "../../images/manufacturerBenefits/organic.svg";
import img3 from "../../images/manufacturerBenefits/search.svg";
import { Row, Col } from "react-bootstrap";
import BenefitsCard from "../BenefitsCard/BenefitsCard";
import { Container } from "@material-ui/core";
export default function AAMCAPPBenefits() {
  const benefits = [
    {
      img: img2,
      title: "Improved Operational Efficiency",
      bodycopy:
        "With easy monitoring and tracking of agri assets and farms, users can optimize resource usage, reduce wastage, and enhance productivity by having real-time data at their fingertips.",
    },
    {
      img: img3,
      title: "Enhanced Asset Quality Control",
      bodycopy:
        "The app ensures that only high-quality and verified agricultural assets are delivered, minimizing risks associated with inferior or unverified assets and ensuring compliance with industry standards.",
    },
    {
      img: img1,
      title: "Streamlined Billing Process",
      bodycopy:
        "Monthly invoicing for agri assets makes financial management more efficient, reducing manual paperwork and the chances of errors, while providing transparent and organized financial records.",
    },

    {
      img: img1,
      title: "Increased Trust and Reliability",
      bodycopy:
        "As only verified assets are delivered, users can have greater confidence in the products or services they are receiving, improving business relationships and customer satisfaction.",
    },
    {
      img: img1,
      title: "Compliance and Accountability",
      bodycopy:
        "The app’s focus on verified assets ensures compliance with regulations and industry standards, fostering accountability throughout the supply chain and reducing legal or financial risks.",
    },

    {
      img: img1,
      title: "Better Decision Making",
      bodycopy:
        "Access to accurate tracking and quality assurance data enables users to make informed decisions regarding their farm operations and asset management, leading to improved profitability and sustainability.",
    },

    {
      img: img1,
      title: "Time and Cost Savings",
      bodycopy:
        "Automated tracking, monitoring, and invoicing save time and reduce labor costs associated with manual processes, allowing users to focus more on core farming activities.",
    },
  ];
  return (
    <div className="">
      <Container className="subSectionWrapper ">
        <h2 className="text-center container-title mb-4">Benefits</h2>
        <Row>
          {benefits.map((e, index) => {
            return (
              <Col md={4} key={index} className="d-flex">
                <BenefitsCard
                  src={e.img}
                  title={e.title}
                  bodycopy={e.bodycopy}
                />
              </Col>
            );
          })}
        </Row>
      </Container>
    </div>
  );
}
